import { useMutation, useQuery } from "react-query";
import {
  getAllUsers,
  getUserList,
  getSingleUser,
  getUserHotels,
  getUserInvitations,
  updateUserStatus,
  addUserInvitation,
  getEnvelopeSignerHotels,
  getApplicationPermission,
  AddUserApplicationPermissions,
  getUserByIdOrRoleId,
  createUser,
  updateUser,
  checkUserNameAvailable,
  checkUserName,
  userSearch,
} from "../api/user";

export const useGetAllUsers = (options = {}) =>
  useQuery("useGetAllUsers", getAllUsers, options);

export const useGetUserList = (options = {}) =>
  useQuery("useGetUserList", getUserList, options);

export const useGetSingleUser = (id, options = {}) => {
  return useQuery(["useGetSingleUser", id], () => getSingleUser(id), {
    enabled: !!id,
    ...options,
  });
};

export const useGetUserHotels = (id, options = {}) => {
  return useQuery(["useGetUserHotels", id], () => getUserHotels(id), {
    enabled: !!id,
    ...options,
  });
};

export const useGetUserInvitations = (id, options = {}) => {
  return useQuery(["useGetUserInvitations", id], () => getUserInvitations(id), {
    enabled: !!id,
    ...options,
  });
};

export const useGetUsersByIdOrRoleId = (data, options = {}) => {
  return useQuery(
    ["useGetUsersByIdOrRoleId", data],
    () => getUserByIdOrRoleId(data),
    {
      enabled: !!data?.user_id || !!data?.role_id,
      ...options,
  });
};

export const useGetEnvelopSignerHotels = (data, options = {}) => {
  return useQuery(
    ["useGetEnvelopSignerHotels", data],
    () => getEnvelopeSignerHotels(data),
    {
      enabled: !!data?.id,
      ...options,
    },
  );
};

export const useUpdateUserStatus = (options = {}) =>
  useMutation(updateUserStatus, options);

export const useAddUserInvitation = (options = {}) =>
  useMutation(addUserInvitation, options);

// get Application Permission
export const useGetApplicationPermission = (id, options = {}) => {
  return useQuery(
    ["useGetApplicationPermissionData", id],
    () => getApplicationPermission(id),
    {
      enabled: !!id,
      ...options,
    },
  );
};

// Add User Application Permissions react query hook
export const useAddUserApplicationPermissions = (options) => {
  return useMutation(AddUserApplicationPermissions, options);
};

export const useCreateUser = (options) => {
  return useMutation(createUser, options);
};

export const useUpdateUser = (options) => {
  return useMutation(updateUser, options);
};

export const useCheckUserNameAvailable = (options) => {
  return useMutation(checkUserName, options);
};
export const useUserSearch = (options = {}) => useMutation(userSearch, options);

export default {
  useGetAllUsers,
  useGetSingleUser,
  useGetUserHotels,
  useGetUserInvitations,
  useUpdateUserStatus,
  useAddUserInvitation,
  AddUserApplicationPermissions,
  useCreateUser,
  useUpdateUser,
  useCheckUserNameAvailable,
  useUserSearch,
};
